import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_xsntmX218hQ8: {
	id: 'prd_xsntm2DEV2X218hQ8'
	ident: 'prd_xsntmX218hQ8'
	sku: 'simple_premium_12w_13_59_12w_79_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: 1
			price_id: 'prc_0GHGD2DEV2ECw5wJu'
			amount: 79
			amount_usd: 13.59
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 13.59
			discount: 65.41
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 12
			iteration_count: null
			price_id: 'prc_j564O2DEV2Iv4qmfq'
			amount: 79
			amount_usd: 79
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_xsntmX218hQ8, SubscriptionProduct>
const prd_xsntmX218hQ8 = { ident: 'prd_xsntmX218hQ8' } as typeof _prd_xsntmX218hQ8

export default prd_xsntmX218hQ8
